import type React from "react"
import { Outlet } from "react-router-dom"
import { ModalProvider } from "../components/modals/modalProvider"
import MobileBottomNavigation from "../components/navbar/Navbar"

const BlankLayout: React.FC = () => {
  return (
    <ModalProvider>
      <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
        <div style={{ flex: 1}}>
          <Outlet />
        </div>
        <MobileBottomNavigation />
      </div>
    </ModalProvider>
  )
}

export default BlankLayout
